import React, { useEffect } from "react"
import withRouter from "components/Common/withRouter"
import { del } from "../../helpers/api_helper"
//redux
import { useNavigate, useParams } from "react-router-dom"
import { REMOVE_PAYMENT_STATUS } from "helpers/api_endpoints"

function RemovePaymentStatus() {
  const history = useNavigate()
  const params = useParams()
  const id = params.id
  const navigate = useNavigate()

  useEffect(() => {
    del(REMOVE_PAYMENT_STATUS, { id })
      .then(response => {
        navigate("/payment-statuses", {
          state: { successMsg: "Payment Status Deleted Successfully" },
        })
      })
      .catch(error => {
        console.log(error)
      })
  })
  return <React.Fragment>Removed</React.Fragment>
}

export default RemovePaymentStatus
